// Keep in sync with api/libs/formatApiLib.js

const stageResource = process.env.NEXT_PUBLIC_STAGE_RESOURCE;

export function materialLinkClip(materialId, name) {
  return new ClipboardItem({
    'text/html': new Blob([materialFullLink(materialId, name)], { type: 'text/html' }),
    'text/plain': new Blob([`${name} (${materialUrl(materialId, 'view')})`], { type: 'text/plain' }),
  });
}

export function materialFullLink(materialId, name) {
  return `<a href="${materialUrl(materialId, 'view')}">${name}</a>`;
}

export function materialSrlClip(materialId) {
  return new ClipboardItem({
    'text/plain': new Blob([materialSrl(materialId)], { type: 'text/plain' }),
  });
}

export function materialSrl(materialId) {
  return `mid://${materialId}/${stageResource}`;
}

export function materialLink(materialId) {
  return `<${materialSrl(materialId)}|${materialSrl(materialId).slice(0, 14)}>`;
}

export function materialUrl(materialId, page) {
  return `${process.env.NEXT_PUBLIC_BASE_URL_DEPLOYED}/${page}?m=${materialId}`;
}

export function cleanUserId(userId) {
  if (!userId) return '';
  return userId.replace('auth0|', 'auth0_');
}

export function unCleanUserId(cleanUserId) {
  if (!cleanUserId) return '';
  return cleanUserId.replace('auth0_', 'auth0|');
}

export function uploadSrl(uploadId) {
  return `tid://${uploadId}/${stageResource}`;
}

export function userSrl(userId) {
  if (!userId) return '';
  return `uid://${cleanUserId(userId)}/${stageResource}`;
}

export function userLink(userId) {
  return `<${userSrl(userId)}|${userId.slice(0, 12)}>`;
}
